module.exports = __webpack_public_path__ + "static/img/ESGS2023.ab2c89a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ESGS2023.png
// module id = 6xn3
// module chunks = 1